import * as XLSX from "xlsx";

export const exportExcel = (data, fileName = "data.xlsx", headers = null) => {
  if (!data || data.length === 0) return;

  let worksheetData;

  if (headers && headers.length) {
    // Map headers first, then data rows
    const headerLabels = headers.map((h) => h.label);
    const headerKeys = headers.map((h) => h.key);
    const rows = data.map((item) => headerKeys.map((key) => item[key] ?? ""));
    worksheetData = [headerLabels, ...rows];
  } else {
    // Fallback to keys from first item
    worksheetData = XLSX.utils.json_to_sheet(data, { skipHeader: false });
  }

  const worksheet =
    headers && headers.length
      ? XLSX.utils.aoa_to_sheet(worksheetData)
      : worksheetData;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
  });
};
